module.exports = __webpack_public_path__ + "img/71400.25dfef6e.jpg";